import * as React from 'react';
import { Loader } from '../Loader';
import { injectIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';

// PropType definition
import { jsx as _jsx } from "react/jsx-runtime";
;

// Header component with props and its types
const _HeaderWidget = props => {
  const {
    loader,
    width,
    title,
    disabled,
    isClickable,
    onTriggerClick
  } = props;
  const onWidgetClick = () => {
    if (isClickable && onTriggerClick) {
      onTriggerClick();
    }
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-header ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: loader ? /*#__PURE__*/_jsx(Loader, {
        loader: loader
      }) : /*#__PURE__*/_jsx("div", {
        className: "kc-ui-header-info",
        children: /*#__PURE__*/_jsx("ul", {
          className: `kc-ui-nobullet ${isClickable && "kc-ui-cursor"}`,
          onClick: onWidgetClick,
          children: /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(TranslateText, {
              id: title
            })
          })
        })
      })
    })
  });
};

// Prop type definition for compile time

// Default props
_HeaderWidget.defaultProps = {
  loader: false,
  width: "100%",
  title: "",
  disabled: false,
  isClickable: false,
  onTriggerClick: () => {}
};
export const HeaderWidget = injectIntl( /*#__PURE__*/React.memo(_HeaderWidget));